import styled from 'styled-components';
import { styledHeader, Typography } from './BaseTypes';
import { styledMargin } from '../layout/Margin';

export const H2 = styled.h2<Typography>`
  ${styledHeader}
  ${styledMargin}
  font-size: 46px;
`;
